import { styled, Box } from "@mui/material";

export const PersonContainer = styled(Box)(() => ({
  transform: "translate(16px, 4px)",
}));
